import { z } from "zod/v4";

export const CreateUsageBillingUrlRequestBodySchema = z.object({
  subscriptionLinkId: z.uuid(),
});

export const CreateUsageBillingUrlResponseBodySchema = z.object({
  billingUrl: z.string().optional(),
});

export type CreateUsageBillingUrlRequestBodyType = z.infer<
  typeof CreateUsageBillingUrlRequestBodySchema
>;
export type CreateUsageBillingUrlResponseBodyType = z.infer<
  typeof CreateUsageBillingUrlResponseBodySchema
>;
